import { render, staticRenderFns } from "./file-info-versions-shares.vue?vue&type=template&id=d324a210&scoped=true"
import script from "./file-info-versions-shares.vue?vue&type=script&lang=js"
export * from "./file-info-versions-shares.vue?vue&type=script&lang=js"
import style0 from "./file-info-versions-shares.vue?vue&type=style&index=0&id=d324a210&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d324a210",
  null
  
)

export default component.exports